const devConfig = {
  basename: '/',
  api: "https://hkdc-membership.juicyapp.dev/member/api",
  menu: {
    canLogout: true,
    canEditProfile: true,
    canAddCard: true,
    topSettingItems: [
      { url: 'contact-us', title: 'setting.contact-info' },
      { url: 'frequently-asked-question', title: 'setting.faq' }
    ],
    bottomSettingItems: [
      { url: 'terms-and-condition', title: 'setting.terms' },
      { url: 'privacy-policy', title: 'setting.privacy' },
      { url: 'copyright-policy', title: 'setting.copyright' }
    ]
  },
  firebase: {
    firebaseConfig: {
      apiKey: "AIzaSyCFdELjVvsH5-O6fv6i2bJol_5sgFWK-KU",
      authDomain: "hkdc-fansnfellows-web-uat.firebaseapp.com",
      projectId: "hkdc-fansnfellows-web-uat",
      storageBucket: "hkdc-fansnfellows-web-uat.appspot.com",
      messagingSenderId: "229369675164",
      appId: "1:229369675164:web:040fb41c783beeec165c59",
      measurementId: "G-Q3MY1TPP1N"
    },
    vapidKey: 'BAAd2fO5ioWVQD7fDmIyoC9ZmMrOJB22P2J7BlHTY7FNRR2YL6a4CVJLFFdZrqyI52aqwPoYUVtPYd2ZvB9e0Ts'
  }
};

export default devConfig;